export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9464.3bda98c8.jpg";